import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.vulnerabilityStatus.label': {
    id: 'profile.vulnerabilityStatus.label',
    defaultMessage: 'Status',
  },
  'profile.vulnerabilityStatus.empty': {
    id: 'profile.vulnerabilityStatus.empty',
    defaultMessage: 'Add your status',
  },
  'profile.vulnerabilityStatus.option.default': {
    id: 'profile.vulnerabilityStatus.option.default',
    defaultMessage: 'Select a status',
  },
  'profile.vulnerabilityStatus.placeholder': {
    id: 'profile.vulnerabilityStatus.placeholder',
    defaultMessage: 'Fill in information about your status',
  },
  'profile.vulnerabilityStatus.option.military': {
    id: 'profile.vulnerabilityStatus.option.military',
    defaultMessage: 'Active military service member',
  },
  'profile.vulnerabilityStatus.option.veteran': {
    id: 'profile.vulnerabilityStatus.option.veteran',
    defaultMessage: 'Veteran',
  },
  'profile.vulnerabilityStatus.option.veteranFamily': {
    id: 'profile.vulnerabilityStatus.option.veteranFamily',
    defaultMessage: 'Family member of a veteran',
  },
  'profile.vulnerabilityStatus.option.militaryFamily': {
    id: 'profile.vulnerabilityStatus.option.militaryFamily',
    defaultMessage: 'Family member of active military service members',
  },
  'profile.vulnerabilityStatus.option.singleParent': {
    id: 'profile.vulnerabilityStatus.option.singleParent',
    defaultMessage: 'Single mother / father',
  },
  'profile.vulnerabilityStatus.option.idp': {
    id: 'profile.vulnerabilityStatus.option.idp',
    defaultMessage: 'Internally displaced person',
  },
  'profile.vulnerabilityStatus.option.refugee': {
    id: 'profile.vulnerabilityStatus.option.refugee',
    defaultMessage: 'Temporary protection / refugee abroad',
  },
  'profile.vulnerabilityStatus.option.disability': {
    id: 'profile.vulnerabilityStatus.option.disability',
    defaultMessage: 'Person with a disability',
  },
  'profile.vulnerabilityStatus.option.unemployed': {
    id: 'profile.vulnerabilityStatus.option.unemployed',
    defaultMessage: 'Unemployed',
  },
  'profile.vulnerabilityStatus.option.fop': {
    id: 'profile.vulnerabilityStatus.option.fop',
    defaultMessage: 'Individual entrepreneur (FOP)',
  },
  'profile.vulnerabilityStatus.option.preferNotToSay': {
    id: 'profile.vulnerabilityStatus.option.preferNotToSay',
    defaultMessage: 'Prefer not to say',
  },
});

export default messages;
